import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IResponsiveSpacerProps extends IBaseElementProps {}

/**
 * ResponsiveSpacer
 * @block
 * @requiresHooks
 * @icon button
 */
const ResponsiveSpacer: React.FC<IResponsiveSpacerProps> = ({
	className,
	classNames = [],
}) => (
	<div className={className || cn('responsive-spacer', ...classNames)}></div>
);

export default ResponsiveSpacer;
